import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiCategory } from '../models';
import { API_BASE_URL } from '../tokens/api-base-url.token';

/** Catalog data access, built against the environment base URL (dev/demo/prod → *.iotzen.app). */
@Injectable({ providedIn: 'root' })
export class CatalogService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  /**
   * Live category + products for the signed-in store/terminal.
   * `locationId` = the store id, `terminalId` = the asset id (both from login).
   *
   * Field-includes (`categoryFI` / `productFI`) and `ngsw-bypass` are passed
   * verbatim; Angular's param codec leaves the `,` and `/` in them untouched.
   * Returns an array of categories, each with its own products.
   */
  getCategoryProducts(locationId: string, terminalId: string): Observable<ApiCategory[]> {
    const categoryFI = 'name,_id,sequence,regionalLanguage,parcelCharge';
    const productFI =
      '_id,skuCode,regionalLanguage,groups,metaInfo.itemName,metaInfo.price,metaInfo.outOfStockStatus,' +
      'metaInfo.categoryIds,metaInfo.description,veg/nonVeg,metaInfo.addOns,parcelCharge,' +
      'assetsLinked,metaInfo.isInventoryEnabled,metaInfo.quantity';
    const url =
      `${this.baseUrl}/api/sok/oms/categoryInfo/products/locationId/${locationId}/` +
      `?isPopulate=true&terminalId=${terminalId}` +
      `&categoryFI=${categoryFI}&productFI=${productFI}&ngsw-bypass=true&isOms=true`;
    return this.http.get<ApiCategory[]>(url);
  }
}
